<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    :class="
      cn('flex aspect-square size-4 items-center justify-center', props.class)
    "
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      fill="none"
      :stroke-width="props.strokeWidth"
      class="h-full w-full text-current"
    >
      <circle
        class="spinner-chase"
        cx="25"
        cy="25"
        r="20"
        stroke="currentColor"
        stroke-linecap="round"
        fill="none"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
  import { cn } from '../lib/utils'

  export interface SpinnerProps {
    class?: string
    strokeWidth?: number
  }

  const props = withDefaults(defineProps<SpinnerProps>(), {
    strokeWidth: 4
  })
</script>

<style scoped>
  /* Simple solid circle (no gaps) */
  .spinner-rotate {
    transform-origin: 50% 50%;
    stroke-dasharray: none;
    animation: spinner-rotate 1s linear infinite;
  }

  /* Circle with dash animation (chasing effect) */
  .spinner-chase {
    stroke-dasharray: 150;
    stroke-dashoffset: 0;
    transform-origin: 50% 50%;
    animation:
      spinner-rotate 1s linear infinite,
      spinner-dash 1.5s ease-in-out infinite;
  }

  @keyframes spinner-rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes spinner-dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
</style>
